import styled from "styled-components";
import colors from "../../../theme/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 303px;
  margin: 0 auto;
  text-align: center;
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 136px;
  height: 136px;
  border-radius: 50%;
  background: #e6e6e6;

  img {
    width: 88px;
    height: 88px;
    object-fit: contain;
  }
`;

export const Title = styled.h3`
  font-family: "Nunito Sans";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 1.32;
  letter-spacing: -0.32px;
  color: ${colors.contentAccent};
  margin: 0;
`;

export const SubTitle = styled.h4`
  font-family: "Nunito Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 1.32;
  color: ${colors.contentAccent};
  margin: 0;
  max-width: 303px;
`;

export const Button = styled.button`
  font-family: "Nunito Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  height: 48px;
  padding: 0 20px;
  border: none;
  border-radius: 12px;
  background: ${colors.primary};
  color: ${colors.onPrimary};
  cursor: pointer;
  transition: background 0.15s ease-in-out;

  &:hover {
    background: ${colors.primaryHover};
  }
`;
